var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusname(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 0H0.875C0.35 0 0 0.35 0 0.875V13.125C0 13.65 0.35 14 0.875 14H20.125C20.65 14 21 13.65 21 13.125V0.875C21 0.35 20.65 0 20.125 0ZM8.75 7.875C8.75 8.4 8.4 8.75 7.875 8.75H4.375C3.85 8.75 3.5 8.4 3.5 7.875V4.375C3.5 3.85 3.85 3.5 4.375 3.5H7.875C8.4 3.5 8.75 3.85 8.75 4.375V7.875ZM16.625 10.5H11.375C10.85 10.5 10.5 10.15 10.5 9.625C10.5 9.1 10.85 8.75 11.375 8.75H16.625C17.15 8.75 17.5 9.1 17.5 9.625C17.5 10.15 17.15 10.5 16.625 10.5ZM16.625 5.25H11.375C10.85 5.25 10.5 4.9 10.5 4.375C10.5 3.85 10.85 3.5 11.375 3.5H16.625C17.15 3.5 17.5 3.85 17.5 4.375C17.5 4.9 17.15 5.25 16.625 5.25Z",
    fill: "#112240"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusname);
export default __webpack_public_path__ + "static/media/icon-busname.d9754a46.svg";
export { ForwardRef as ReactComponent };